import React from 'react'
import PortalMessage from 'Utility/PortalMessage'
import PortalTextLink from '@nexidigital/portaltextlink'

const formattedMessage = {
  back: <PortalMessage
    id='t.app.back'
    defaultMessage='Indietro'
        />,
  titleNavigation: (
    <PortalMessage
      id='t.app.paybylink.titleNavigation'
      defaultMessage='Incassa con Pay-by-Link'
    />
  ),
  homepage: (
    <PortalMessage
      id='t.app.homepage'
      defaultMessage='Homepage'
    />
  ),
  services: (
    <PortalMessage
      id='t.app.homepage.menuContent.servicesTitle'
      defaultMessage='Servizi'
    />
  ),
  statusOptionNotPaid: (
    <PortalMessage
      id='t.app.paybylink.transactionStatus.notPaid'
      defaultMessage='Non pagato'
    />
  ),
  statusOptionPaid: (
    <PortalMessage
      id='t.app.paybylink.transactionStatus.paid'
      defaultMessage='Pagato'
    />
  ),
  statusOptionDenied: (
    <PortalMessage
      id='t.app.paybylink.transactionStatus.denied'
      defaultMessage='Negato'
    />
  ),
  statusOptionFailed: (
    <PortalMessage
      id='t.app.paybylink.transactionStatus.failed'
      defaultMessage='Fallito'
    />
  ),
  statusOptionExpired: (
    <PortalMessage
      id='t.app.paybylink.transactionStatus.expired'
      defaultMessage='Scaduto'
    />
  ),

  pageTitle: (
    <PortalMessage
      id='t.app.cashIn'
      defaultMessage='Incassa'
    />
  ),
  pageSubtitle: (
    <PortalMessage
      id='t.app.paybylink.pageSubtitle'
      defaultMessage='Richiedi pagamenti incassando tramite il servizio Pay-By-Link.'
    />
  ),
  pageSubtitleTextlinkCopy: (onTextLinkClick) => (
    <PortalMessage
      id='t.app.paybylink.pageSubtitleTextlinkCopy'
      defaultMessage='Puoi abilitare gli incassi a distanza su più punti vendita. {textLink}'
      values={{
        textLink: (
          <PortalTextLink
            onClick={onTextLinkClick}
            label={
              <PortalMessage
                id='t.app.paybylink.pageSubtitleTextlinkCopy.textLink'
                defaultMessage='ABILITA PUNTO VENDITA'
              />
            }
            underline='none'
          />
        )
      }}
    />
  ),
  ctaLabel: (
    <PortalMessage
      id='t.app.paybylink.ctaLabel'
      defaultMessage='Richiedi pagamento'
    />
  ),
  filterLabel: (
    <PortalMessage
      id='t.app.paybylink.filterLabel'
      defaultMessage='Filtra'
    />
  ),
  resetFilters: (
    <PortalMessage
      id='t.app.paybylink.resetFilters'
      defaultMessage='azzera filtri'
    />
  ),
  tablePblTitle: (
    <PortalMessage
      id='t.app.paybylink.table.title'
      defaultMessage='Storico Incassi'
    />
  ),
  tableTotalLabel: (
    <PortalMessage
      id='t.app.paybylink.table.totalLabel'
      defaultMessage='Totale link generati'
    />
  ),
  expirationLabel: (
    <PortalMessage
      id='t.app.paybylink.table.expirationLabel'
      defaultMessage='Scade il'
    />
  ),
  thLabelOrderNumber: (
    <PortalMessage
      id='t.app.paybylink.table.th.orderNumber'
      defaultMessage='Numero ordine'
    />
  ),
  thLabelLinkExpirationDate: (
    <PortalMessage
      id='t.app.paybylink.table.th.linkExpirationDate'
      defaultMessage='Scadenza link'
    />
  ),
  thLabelClientName: (
    <PortalMessage
      id='t.app.paybylink.table.th.clientName'
      defaultMessage='Nome cliente'
    />
  ),
  thLabelReason: (
    <PortalMessage
      id='t.app.paybylink.table.th.reason'
      defaultMessage='Causale pagamento'
    />
  ),
  thLabelAmount: (
    <PortalMessage
      id='t.app.paybylink.table.th.amount'
      defaultMessage='Importo'
    />
  ),
  thLabelStatus: (
    <PortalMessage
      id='t.app.paybylink.table.th.status'
      defaultMessage='Stato'
    />
  ),
  emptyTablePbl: (
    <PortalMessage
      id='t.app.paybylink.emptyTable'
      defaultMessage='Nessuna richiesta da visualizzare'
    />
  ),
  emptyTablePblSubtitle: (
    <PortalMessage
      id='t.app.paybylink.emptyTableSubtitle'
      defaultMessage='Appena disponibili, potrai consultare qui le richieste di pagamento effettuate.'
    />
  ),
  errorStateTitle:
  <PortalMessage
    id='t.app.emptyState.title'
    defaultMessage='Dati temporaneamente non disponibili'
  />,
  errorStateSubtitle: (
    <PortalMessage
      id='t.app.emptyState.subtitle'
      defaultMessage='I dati non sono disponibili a causa di un problema tecnico, {dynamicParam} la pagina oppure riprova più tardi.'
      values={{
        dynamicParam: (
          <PortalTextLink
            onClick={() => window.location.reload()}
            label={
              <PortalMessage
                id='t.app.reload'
                defaultMessage='ricarica'
              />
            }
            underline='always'
          />
        )
      }}
    />
  ),
  emptyTablelabel: (
    <PortalMessage
      id='t.app.paybylink.emptyTable.label'
      defaultMessage='Non sono presenti risultati per la ricerca effettuata.'
    />
  ),
  emptyTableSearchLabel: (
    <PortalMessage
      id='t.app.paybylink.emptyTable.search.label'
      defaultMessage='Non sono presenti richieste di pagamento per i filtri da te impostati. Modificali e riprova.'
    />
  ),

  // Detail modal
  transactionDetailNavTitle: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.navTitle'
      defaultMessage='Dettaglio ordine'
    />
  ),
  transactionDetailOrderDetailTitle: (ordernumber) => (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.title'
      defaultMessage='Ordine {ordernumber}'
      values={{
        ordernumber
      }}
    />
  ),
  transactionDetailOrderNumber: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.orderNumber'
      defaultMessage='Ordine'
    />
  ),
  transactionDetailOrderDateTime: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.orderDateTime'
      defaultMessage='Data e ora'
    />
  ),
  transactionDetailFacility: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.facility'
      defaultMessage='Punto vendita'
    />
  ),
  transactionDetailTerminal: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.terminal'
      defaultMessage='Terminal ID (TML)'
    />
  ),
  transactionDetailTypology: (
    <PortalMessage
      id='t.app.type'
      defaultMessage='Tipologia'
    />
  ),
  transactionDetailExpirationDate: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.expirationDate'
      defaultMessage='Scadenza'
    />
  ),
  transactionDetailAmount: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.amount'
      defaultMessage='Importo'
    />
  ),
  transactionDetailStatus: (
    <PortalMessage
      id='t.app.status'
      defaultMessage='Stato'
    />
  ),
  transactionDetailPaymentDate: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.paymentDate'
      defaultMessage='Data pagamento'
    />
  ),
  transactionDetailStatusDetail: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.statusDetail'
      defaultMessage='Dettaglio stato'
    />
  ),
  transactionFailedDetailStatusDetail: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.statusDetail.failed'
      defaultMessage='Pagamento fallito'
    />
  ),
  transactionDetailClientName: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.clientName'
      defaultMessage='Nome cliente'
    />
  ),
  transactionDetailPaymentDescription: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.paymentDescription'
      defaultMessage='Causale'
    />
  ),
  transactionDetailReason: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.reason'
      defaultMessage='Causale'
    />
  ),

  transactionDetailPaid: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.payed'
      defaultMessage='Richiedi nuovo pagamento'
    />
  ),
  transactionDetailNotPaid: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.notPayed'
      defaultMessage='Richiedi pagamento'
    />
  ),
  transactionDetailFailed: (
    <PortalMessage
      id='t.app.paybylink.transactionDetail.failed'
      defaultMessage='Richiedi nuovo link'
    />
  ),
  socialSharingTitle: (
    <PortalMessage
      id='t.app.paybylinkoutcome.socialsharing.title'
      defaultMessage='Copia o condividi il link di pagamento tramite i seguenti canali:'
    />
  ),
  socialSharingCopy: (
    <PortalMessage
      id='t.app.paybylinkoutcome.socialsharing.copy'
      defaultMessage='Copia'
    />
  ),
  socialSharingEmail: (
    <PortalMessage
      id='t.app.email'
      defaultMessage='Email'
    />
  ),
  socialSharingWhatsApp: (
    <PortalMessage
      id='t.app.paybylinkoutcome.socialsharing.whatsapp'
      defaultMessage='WhatsApp'
    />
  ),
  socialSharingTelegram: (
    <PortalMessage
      id='t.app.paybylinkoutcome.socialsharing.telegram'
      defaultMessage='Telegram'
    />
  ),
  copySuccess: (
    <PortalMessage
      id='t.app.paybylinkoutcome.copy.success'
      defaultMessage='Link copiato con successo'
    />
  ),

  close: (
    <PortalMessage
      id='t.app.close'
      defaultMessage='Chiudi'
    />
  ),
  pblShopType: (
    <PortalMessage
      id='t.app.shopType.payByLink'
      defaultMessage='Pay-By-Link'
    />
  ),
  shareLink: (
    <PortalMessage
      id='t.app.paybylink.shareLink'
      defaultMessage='Condividi link'
    />
  ),
  menuItemsSupport: <PortalMessage id='t.app.support' defaultMessage='Assistenza' />
}

export default formattedMessage
